import React, { createContext, useContext, useState, useEffect } from 'react';

interface UserData {
    id: string;
    name: string;
    email: string;
}

interface UserContextType {
    userData: UserData | null;
    setUserData: (data: UserData | null) => void;
    user: UserData | null;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [userData, setUserData] = useState<UserData | null>(null);

    useEffect(() => {
        // Aqui você pode adicionar a lógica para carregar os dados do usuário
        // Por exemplo, verificar se há dados salvos no localStorage
        const savedUserData = localStorage.getItem('userData');
        if (savedUserData) {
            setUserData(JSON.parse(savedUserData));
        }
    }, []);

    return (
        <UserContext.Provider value={{ userData, setUserData, user: userData }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
}; 